import { render, staticRenderFns } from "./PspView.vue?vue&type=template&id=456a63e1&scoped=true&"
import script from "./PspView.vue?vue&type=script&lang=js&"
export * from "./PspView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a63e1",
  null
  
)

export default component.exports